import React from 'react';

const CaptainAmerica = (props) => {
  const { generations } = props;
  const radius = generations[0].thickness;

  const width = 358 * (radius / 178); //radius;
  const height = 358 * (radius / 178); // radius;
  return (
    <svg width={`${width}px`} height={`${height}px`} x={-width / 2} y={-height / 2} viewBox="0 0 358 358" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <g id="Group" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <circle id="Oval-6" fill="#193070" cx="179" cy="179" r="179"></circle>
          <polygon id="Star-2" fill="#FFFFFF" points="179 255.714286 88.8169484 303.126322 106.040379 202.706018 33.0807574 131.587964 133.908474 116.936839 179 25.5714286 224.091526 116.936839 324.919243 131.587964 251.959621 202.706018 269.183052 303.126322"></polygon>
      </g>
    </svg>
  )
}

export function resize(props) {
  return props;
}

export default CaptainAmerica;


// WEBPACK FOOTER //
// ./src/core/thematic/captain-america/index.js